module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Petit-Val_COA-760fed3ca99f55c2dfb097b7ae38ea68.svg";